import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

import Colours from '/shared/styled/Colours';

export default function activeStyle({
  $active = false,
  $primary = false,
  $outline = false,
  $outlineReplacement = false,
  $hasActiveTick = false,
  $dark = false,
  theme,
}: ButtonStyleProps) {
  if ($active && !$outlineReplacement) {
    if ($primary) {
      return css`
        border-width: 2px;
        transform: translateY(-1px);
        margin-bottom: -2px !important;
        border-color: ${Colours.green};
        opacity: 1 !important;

        ${
          $outline &&
          css`
          * {
            color: ${Colours.green};
          }
        `
        }
        ${
          $dark &&
          css`
          border: 1px solid ${Colours.blackDark1};
          background: ${Colours.blackDark1};
          color: ${Colours.white} !important;
        `
        }
        > * > * {
          ${
            $hasActiveTick &&
            css`
            padding-right: 0;
          `
          }
        }
      `;
    }
    return css`
      font-weight: bold;
    `;
  }
}
